import { render, staticRenderFns } from "./AchievementDetailsDialog.vue?vue&type=template&id=0764d940&scoped=true&"
import script from "./AchievementDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./AchievementDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AchievementDetailsDialog.vue?vue&type=style&index=0&id=0764d940&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0764d940",
  null
  
)

export default component.exports